import { COLORS } from '@connect-x-app/shared-ui';

export const shadows = {
  default: {
    elevation: 2,
    shadowColor: COLORS.zulu.$10,
    shadowOffset: {
      height: 2,
      width: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
};
